import _ from 'lodash'
import useValueExchangeLabel from '@/utils/useValueExchangeLabel'
import { getChannelsByType } from '@com/utils/channel'

export function parseChannel(val) {
  const channelList = getChannelsByType()
  if (_.isUndefined(useValueExchangeLabel(val, channelList))) return '-'
  return useValueExchangeLabel(val, channelList)
}

export function parseInteractiveChannel(val) {
  const interactiveChannelList = getChannelsByType('interactive')
  if (_.isUndefined(useValueExchangeLabel(val, interactiveChannelList))) {
    return '-'
  }
  return useValueExchangeLabel(val, interactiveChannelList)
}

export function parseNonInteractiveChannel(val) {
  const nonInteractiveChannelList = getChannelsByType('noninteractive')
  if (_.isUndefined(useValueExchangeLabel(val, nonInteractiveChannelList))) {
    return '-'
  }
  return useValueExchangeLabel(val, nonInteractiveChannelList)
}
